//styles && images
import './Sidebar.css'
import DashboardIcon from '../assets/dashboard_icon.svg'
import  AddIcon from  '../assets/add_icon.svg'

import React from 'react'
import { NavLink } from 'react-router-dom'
import { useAuthcontext } from '../hooks/useAuthcontext'
// import { Avatar } from './Avatar'

export const Sidebar = () => {
    const {user} = useAuthcontext()
  return (
    <div className='sidebar'>
        <div className='sidebar-content'>
            <div className='user'>
                {/* {user && <Avatar src={user.photoURL}/>} */}
                {user && <p>Hey {user.displayName}</p>}
            </div>
            <nav className='links'>
                <ul>
                    <li>
                        <NavLink to="/">
                            <img src={DashboardIcon} alt="dashboard icon"/>
                            <span>Dashboard</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/create">
                            <img src={AddIcon} alt="add project icon icon"/>
                            <span>New Project</span>
                        </NavLink>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
  )
}
